import React from "react";
import '../styles/components/WorkWith.css'


const WorkWith = () => {

    return (
        <>
            <div className='work-with'>
                <h1>الشركات</h1>
                <h2>التـي أعمـل معـهـــا</h2>
                <div className='logos'>
                    <div className='mikropor'></div>
                    <div className='knyt'></div>
                    <div className='imergency'></div>
                    <div className='wbs'></div>
                    <div className='gian'></div>
                </div>
            </div>
        </>
    )
}

export default WorkWith

/*
    <img src={mikropor} alt='mikropor'/>
    <img src={knyt} alt='knyt'/>
    <img src={imergency} alt='imergency'/>
    <img src={wbs} alt='wbs'/>
    <img src={gian} alt='gian'/>
 */